export interface Role {
  id: number;
  title: string;
  slug: string;
}

export const ROLES = {
  10: {
    title: 'Owner',
    id: 10,
    slug: 'owner',
  },
  20: {
    title: 'Manager',
    id: 20,
    slug: 'manager',
  },
  30: {
    title: 'Dispatcher',
    id: 30,
    slug: 'dispatcher',
  },
  40: {
    title: 'Employee',
    id: 40,
    slug: 'employee',
  },
};

export const ROLES_LIST = Object.keys(ROLES).map(
  (key) => ROLES[key as unknown as keyof typeof ROLES],
);
